import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { BroadcastComponent } from './broadcast.component';



@NgModule({
  declarations: [
    BroadcastComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    BroadcastComponent
  ]
})
export class BroadcastModule { }
